<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-list two-line subheader>
          <v-subheader inset>Settings</v-subheader>
          <v-list-tile avatar v-for="item in items" v-bind:key="item.title" @click="item.action">
            <v-list-tile-avatar>
              <v-icon v-bind:class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon class="grey lighten-1 white--text">camera</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Camera Quality</v-list-tile-title>
              <v-slider min="20" class="px-3" v-model="cameraQuality" thumb-label step="10" ticks></v-slider>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list two-line subheader>
          <v-subheader inset>Job Queue</v-subheader>
          <v-list-tile v-for="job in jobQueueArray" v-bind:key="job">
            <v-list-tile-avatar></v-list-tile-avatar>
            <v-list-tile-content>
              Job Number : {{jobQueue[job].JobNo}}
            </v-list-tile-content>
            <!-- <v-list-tile-action>
              <v-btn color="primary" @click="uploadJob(job)" :loading = "sendingJob === job">Upload</v-btn>
            </v-list-tile-action> -->
          </v-list-tile>
        </v-list>
        <!-- <v-text-field textarea 
          name="input-1"
          label="Debug Window"
          v-model="debug"
        >
        </v-text-field> -->
      </v-card>
    </v-flex>
    <v-snackbar
      v-model="snackbar"
    >
      {{snackbarText}}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  import idb from 'idb'
  import dbPromise from '../dbPromise'
  import { fireStore, storage } from '../firebase'
  export default {
    data () {
      return {
        items: [
          { icon: 'history', iconClass: 'grey lighten-1 white--text', title: 'Reset', subtitle: 'Refresh the app to get the latest version', action: this.resetApp },
          { icon: 'delete', iconClass: 'grey lighten-1 white--text', title: 'Clear All Data', subtitle: 'Clear all the data on app', action: this.clearApp },
          { icon: 'cloud_download', iconClass: 'grey lighten-1 white--text', title: 'Get Data', subtitle: 'Get data from app', action: this.getData }
        ],
        snackbar: false,
        snackbarText: '',
        cameraQuality: 0,
        jobQueue: {},
        jobQueueArray: [],
        sending: 0,
        sendingJob: -1,
        debug: ''
      }
    },
    watch: {
      cameraQuality: function (val) {
        localStorage.setItem('cameraQuality', val)
      }
    },
    created () {
      this.getJobQueue()
      this.cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 50
    },
    computed: {
      customers () {
        return this.$store.getters.customers
      }
    },
    methods: {
      resetApp () {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          for (let registration of registrations) {
            registration.unregister()
          }
        })
        .then(function (boolean) {
          caches.delete('v1-engineer-cache').then(function (boolean) {
            window.location.reload(true)
          })
        })
      },
      clearApp () {
        this.snackbar = true
        this.snackbarText = 'Clearing Data'
        idb.delete('engineer-db').then(() => {
          this.snackbar = true
          this.snackbarText = 'Data Cleared'
        })
      },
      getData () {
        let text = ''
        let images = ''
        dbPromise().then(function (db) {
          let tx = db.transaction('outbox')
          let outboxStore = tx.objectStore('outbox')
          return (outboxStore.getAll())
        }).then((val) => {
          text += JSON.stringify(val)
          var element = document.createElement('a')
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
          element.setAttribute('download', 'text.txt')

          element.style.display = 'none'
          document.body.appendChild(element)

          element.click()

          document.body.removeChild(element)
        })

        dbPromise().then(function (db) {
          let tx = db.transaction('imageStore')
          let outboxStore = tx.objectStore('imageStore')
          return (outboxStore.getAll())
        }).then((val) => {
          images += JSON.stringify(val)
          var element = document.createElement('a')
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(images))
          element.setAttribute('download', 'images.txt')

          element.style.display = 'none'
          document.body.appendChild(element)

          element.click()

          document.body.removeChild(element)
        })
      },
      uploadJob (jobKey) {
        this.sendingJob = jobKey
        // Get single outbox item
        this.debug += 'Preparing to send key:' + jobKey + '\n'
        dbPromise().then(function (db) {
          let tx = db.transaction('outbox')
          let outboxStore = tx.objectStore('outbox')
          return (outboxStore.get(jobKey))
        }).then((val) => {
          // let jobNumber = val.number
          let job = val
          let jobNumbers = []
          const customerIndex = this.customers.findIndex(customer => {
            return job.customer === customer.id
          })
          const shortName = this.customers[customerIndex]['shortName']

          fireStore.collection('Jobs').where('Customer', '==', job.customer).get()
          .then(snap => {
            snap.forEach(doc => {
              jobNumbers.push(doc.data().JobNo.replace(shortName, ''))
            })
            jobNumbers.sort((a, b) => {
              return b - a
            })
            job.JobNo = shortName + this.zeroFill(parseInt(jobNumbers[0]) + 1, 4)
            console.log(job)
            let templates = []
            if (job.templates) {
              templates = job.templates
            }
            let unscheduled = 0
            if (job.unscheduled) {
              unscheduled = job.unscheduled
            }
            fireStore.collection('Jobs').add({JobNo: job.JobNo, Customer: job.customer, Date: job.Date, Vehicle: job.vehicle, templates: templates, unscheduled: unscheduled})
            .then(docRef => {
              const doc = docRef.id
              let jobNumber = job.JobNo
              let toDelete = []
              this.debug += 'Job Number is:' + jobNumber + '\n'
              for (let template in val.template) {
                this.debug += 'Looping Templates Pass' + template + '\n'
                for (let item in val.template[template].items) {
                  this.debug += 'Looping Templates Items Pass' + item + '\n'
                  if (val.template[template].items[item].image !== '') {
                    this.debug += item + 'Has Image! \n'
                    toDelete.push(val.template[template].items[item].image)
                    this.debug += item + 'Added to delete queue! \n'
                    dbPromise().then(function (db) {
                      let tx = db.transaction('imageStore')
                      let imageStore = tx.objectStore('imageStore')
                      return (imageStore.get(val.template[template].items[item].image))
                    })
                    .then((image) => {
                      if (image !== undefined) {
                        this.debug += item + 'Successfully retreived image from local db! \n'
                        // Prepare image for sending
                        let bytes = image.image
                        let ref = storage.ref(jobNumber + '/' + image.name)
                        this.sending++
                        // Send image
                        console.info('Sending image')
                        ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
                        .then((snapshot) => {
                          job.template[template].items[item].image = snapshot.downloadURL
                          job.template[template].items[item].imageName = image.name
                        // Image has been successful so safe to remove from IDB
                          // On successful removal change flag and check if anything is still sending
                          this.sending--
                          console.log(this.sending)
                          this.debug += this.sending + 'Successfully Uploaded Image! \n'
                          if (this.sending === 0) {
                            this.debug += 'All Images Have been uploaded! \n'
                            // If all images have been sent -> send data
                            fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
                            .set(job)
                            .then(() => {
                              fireStore.collection('Jobs/').doc(doc).update({Status: 2})
                              this.debug += 'Job data sent! \n'
                              // Data has been successful so safe to remove from IDB
                              dbPromise().then(function (db) {
                                let tx = db.transaction('outbox', 'readwrite')
                                let outboxStore = tx.objectStore('outbox')
                                outboxStore.delete(parseInt(jobKey))
                              }).then(() => {
                                this.debug += 'Cleared local data! \n'
                                this.snackbar = true
                                this.snackbarText = 'Upload Successful'
                                for (let i in toDelete) {
                                  dbPromise().then(function (db) {
                                    this.debug += 'Cleared local images! \n'
                                    let tx = db.transaction('imageStore', 'readwrite')
                                    let imageStore = tx.objectStore('imageStore')
                                    imageStore.delete(toDelete[i])
                                  })
                                }
                              })
                            })
                            this.debug += 'Finished sending! \n'
                            this.snackbar = true
                            this.snackbarText = 'Finished Sending'
                            this.getJobQueue()
                          }
                        })
                        .catch((error) => {
                          this.sendingJob = -1
                          this.sending--
                          console.log(error)
                          this.snackbarText = 'Unable to send. Will try later'
                          this.snackbar = true
                          this.debug += 'Error:' + error.message + '! \n'
                        })
                      } else {
                        this.debug += item + 'No Image found in local db! \n'
                      }
                    })
                  }
                }
              }
            })
          })
        })
      },
      getJobQueue () {
        this.jobQueueArray = []
        this.sendingJob = -1
        dbPromise().then(function (db) {
          let tx = db.transaction('outbox')
          let outboxStore = tx.objectStore('outbox')
          return (outboxStore.getAllKeys())
        }).then((keys) => {
          for (const key in keys) {
            if (keys.hasOwnProperty(key)) {
              const element = keys[key]
              dbPromise().then(function (db) {
                let tx = db.transaction('outbox')
                let outboxStore = tx.objectStore('outbox')
                return (outboxStore.get(element))
              }).then((val) => {
                this.jobQueue[element] = val
                this.jobQueueArray.push(element)
              })
            }
          }
        })
      },
      zeroFill (number, width) {
        width -= number.toString().length
        if (width > 0) {
          return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
        }
        return number
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Settings.vue?12cb5599